import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="portfolio">
                <h1>Passion-Fueled Innovation: Where Dreams Become Reality</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol is not just a service provider; we are an invaluable
                  extension of your marketing team, bringing a powerful
                  combination of strategic thinking, expertise, and flawless
                  execution to the areas where you need it the most.
                </p>
                <ul>
                  <li>Strategic Planning</li>
                  <li>Cutting-Edge Technologies</li>
                  <li>Unconventional App Experience</li>
                  <li>Creative Solutions</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
